import { INoticeType, verifyIcon } from "@pjs/core-ui";
export const verifiedNotice: INoticeType = {
    colour: "#0077BB",
    icon: verifyIcon
};
